module.exports = __webpack_public_path__ + "images/9fb8ddf7d3da3e4d0b2ec9ba493699c9.png";